export default "__VITE_ASSET__O$QgWn6V__"